/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Rest_Api_Faq_Q1Inputs */

const en_guide_json_rest_api_faq_q1 = /** @type {(inputs: Guide_Json_Rest_Api_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why do APIs use JSON instead of XML?`)
};

const ko_guide_json_rest_api_faq_q1 = /** @type {(inputs: Guide_Json_Rest_Api_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API는 왜 XML 대신 JSON을 사용하나요?`)
};

const ja_guide_json_rest_api_faq_q1 = /** @type {(inputs: Guide_Json_Rest_Api_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`なぜAPIはXMLの代わりにJSONを使用するのですか？`)
};

/**
* | output |
* | --- |
* | "Why do APIs use JSON instead of XML?" |
*
* @param {Guide_Json_Rest_Api_Faq_Q1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_rest_api_faq_q1 = /** @type {((inputs?: Guide_Json_Rest_Api_Faq_Q1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Rest_Api_Faq_Q1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_rest_api_faq_q1(inputs)
	if (locale === "ko") return ko_guide_json_rest_api_faq_q1(inputs)
	return ja_guide_json_rest_api_faq_q1(inputs)
});